import qz from "qz-tray";

// Connect to QZ Tray and get printers
export const initQZTray = async () => {
  try {
    await qz.websocket.connect();
    console.log("✅ QZ Tray connected");

    const printers = await qz.printers.find();
    console.log("Available printers:", printers);
    return printers;
  } catch (err) {
    console.error("❌ QZ Tray connection failed:", err);
  }
};
